import * as React from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import FetchInputSelectOptions from '../../FetchInputSelectOptions';
import InputSelect from '../InputSelect';
import fetchBloodTypeOptions from '../../../services/blood_type_services';

const BloodTypeInputSelect = ({ submitOnChange, ...props }) => {
  const { setFieldValue, submitForm } = useFormikContext();

  return (
    <FetchInputSelectOptions fetchOptions={fetchBloodTypeOptions}>
      {({ options, isLoading }) => (
        <InputSelect
          name="blood_type"
          label="Tipo Sanguínio"
          placeholder="Selecionar"
          options={options}
          isLoading={isLoading}
          getOptionValue={(d) => d.id}
          getOptionLabel={(d) => d.name}
          onChange={(value) => {
            if (value) {
              setFieldValue('blood-type', '');
            }
            if (submitOnChange) {
              submitForm();
            }
          }}
          {...props}
        />
      )}
    </FetchInputSelectOptions>
  );
};

BloodTypeInputSelect.propTypes = {
  submitOnChange: PropTypes.bool,
};

BloodTypeInputSelect.defaultProps = {
  submitOnChange: false,
};

export default BloodTypeInputSelect;
